<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px">
          <el-row :gutter="20">
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item label="接口名称" prop="requestUri">
                <ic-select table="apiLog" field="requestUri" v-model="queryCondition.requestUri" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item label="请求信息" prop="requestMessage">
                <el-input v-model="queryCondition.requestMessage" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item label="返回信息" prop="responseMessage">
                <el-input v-model="queryCondition.responseMessage" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item label="返回信息" prop="dateRange">
                <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width:100%">
                </el-date-picker>
                <!-- <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createDateFrom" type="date" :placeholder="'Select Date'" style="width: 180px;"></el-date-picker> -->
                <!-- To -->
                <!-- <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createDateTo" type="date" :placeholder="'Select Date'" style="width: 180px;"></el-date-picker> -->
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item label="报错信息" prop="responseMessage">
                <el-input v-model="queryCondition.responseMessage" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="queryData(1)">{{$t("common.search")}}</el-button>
          </el-row>
        </el-form>
        <u-table sortable :data="tableData" ref="tableList" border highlight-current-row class="table">
          <u-table-column prop="createDate" :label="$t('common.createDate')">
          </u-table-column>
          <u-table-column prop="requestUri" label="请求类型"></u-table-column>
          <u-table-column :show-overflow-tooltip="true" prop="requestMessage" label="请求信息">
            <template slot-scope="scope">
              <el-button @click="showMessage(scope.row.requestMessage)">查看报文</el-button>
            </template>
          </u-table-column>
          <u-table-column :show-overflow-tooltip="true" prop="responseMessage" label="返回信息">
          </u-table-column>
          <u-table-column :show-overflow-tooltip="true" prop="errorMsg" label="错误信息"></u-table-column>
        </u-table>
        <div class="pagination">
          <!--===分页组件===-->
          <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
        </div>
        <el-dialog :visible="showMessageFlag" :show-close="true" @close="showMessageFlag = false">
          <span>{{message}}</span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import commonFunction from "@/utils/dataTableUtils";
import apiLog from "@/api/system/apiLog";
import IcSelect from "@/components/common/icSelect";

export default {
  name: "apiLog",
  components: { IcSelect },
  extends: commonFunction,
  data: () => {
    return {
      showMessageFlag: false,
      queryCondition: {
        groupName: "",
        category: "",
        userCd: "",
        createDateFrom:"",
        createDateTo:"",
        pageNum: 1,
        pageSize: 15
      },
      dateRange:[],
      message: null,
      totalCount: null,
      tableData: [],
    }
  },
  methods: {
    showMessage(message) {
      this.message = message;
      this.showMessageFlag = true;
    },
    queryData() {
      if (this.dateRange.length>0) {
        this.queryCondition.createDateFrom=this.dateRange[0]
        this.queryCondition.createDateTo=this.dateRange[1]
      }
      apiLog.query(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
      })
    }
  }
}
</script>

<style scoped>
</style>